import { useStatQuery } from '@famly/stat_use-stat-query';
import { StatPermissionsChild } from './stat-permissions-child.query';
export function useStatPermissionsChildQuery(options) {
    const queryResult = useStatQuery(StatPermissionsChild, options);
    // add cache updates here
    return queryResult;
}
